import * as React from "react"
import T from "../T/T";
import "./styles.scss";
import { useState } from "react";
import { navigate } from "gatsby-plugin-intl";

export default function ClaimReward({ showReward }) {
    const [isVisible, setVisible] = useState(!showReward);

    // Define functions
    const close = () => {
        setVisible(false);
    }

    return isVisible ? (
        <div className="sticky-footer">
            <div className="sticky-footer-body">
                <button
                    className="close-icon"
                    onClick={close}
                    aria-label="Close">
                    <img src={'../../../static/images/close-icon.svg'} />
                </button>

                <p>
                    <T>popup-claim-message</T>
                </p>

                <button className="button-light"
                    onClick={() => navigate('/form')}
                >
                    <T>popup-claim-button</T>
                </button>
            </div>
        </div>
    ) : null
}
